"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var AppTabs = /*#__PURE__*/function (_React$Component) {
  _inherits(AppTabs, _React$Component);

  function AppTabs(props) {
    var _this;

    _classCallCheck(this, AppTabs);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AppTabs).call(this, props));
    _this.state = {
      activeTab: null
    };
    return _this;
  }

  _createClass(AppTabs, [{
    key: "tabClick",

    /**
     * Called on tab click
     * @param {Object} tab Clicked tab
     */
    value: function tabClick(tab) {
      var _this2 = this;

      this.setState({
        activeTab: tab.id
      }, function () {
        _this2.props.onTabChange(_this2.state.activeTab);
      });
    }
    /**
     * Render
     */

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var tabs = this.props.tabs;
      var activeTab = this.state.activeTab ? tabs.find(function (x) {
        return x.id == _this3.state.activeTab;
      }) : tabs[0]; // Get active

      var tabsElements = this.tabElements || [];
      tabs.map(function (tab, index) {
        var tabElement = _react["default"].createElement("li", {
          key: 'tab' + index,
          className: activeTab.id === tab.id ? 'active' : ''
        }, _react["default"].createElement("a", {
          href: "javascript:void(0)",
          onClick: function onClick() {
            return _this3.tabClick(tab);
          }
        }, _react["default"].createElement("i", {
          className: 'fa fa-fw fa-' + tab.icon
        }), " ", tab.title));

        tabsElements.push(tabElement);
      });
      this.tabElements = this.tabElements;
      return _react["default"].createElement("div", null, _react["default"].createElement("nav", null, _react["default"].createElement("ul", {
        className: "dashboard-management-nav customers-dashboard-nav"
      }, tabsElements)), activeTab.component);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var stateUpdate = {};

      if (props.activeTab && !state.activeTab) {
        stateUpdate.activeTab = props.activeTab;
      }

      return stateUpdate;
    }
  }]);

  return AppTabs;
}(_react["default"].Component);

exports["default"] = AppTabs;
AppTabs.defaultProps = {
  onTabChange: function onTabChange() {}
};